import { useRef, useState } from "react";
import { X } from "lucide-react";
import { mediaSrc, price } from "./common";

export function LinkCard({ l, onRemove }) {
  const body = (
    <div className="flex overflow-hidden rounded-xl border border-[#2A303C] bg-[#121418] transition-[border-color] hover:border-[#C17F59]">
      {l.image && <img src={l.image} alt="" className="h-20 w-28 shrink-0 object-cover sm:h-24 sm:w-36" onError={(e) => { e.currentTarget.style.display = "none"; }} />}
      <div className="min-w-0 p-3">
        <div className="text-[10px] font-bold uppercase tracking-widest text-[#6B7280]">{l.site}</div>
        <div className="line-clamp-2 text-sm font-semibold text-white">{l.title || l.url}</div>
        {l.description && <div className="line-clamp-1 text-xs text-[#9CA3AF]">{l.description}</div>}
      </div>
    </div>
  );
  return (
    <div className="relative" data-testid="bacheca-link-card">
      {l.youtube_id && !onRemove ? (
        <div className="aspect-video overflow-hidden rounded-xl border border-[#2A303C]">
          <iframe src={`https://www.youtube-nocookie.com/embed/${l.youtube_id}`} title={l.title || "YouTube"} className="h-full w-full" allowFullScreen allow="accelerometer; encrypted-media; picture-in-picture" />
        </div>
      ) : <a href={l.url} target="_blank" rel="noreferrer noopener">{body}</a>}
      {onRemove && <button type="button" onClick={onRemove} className="absolute right-1 top-1 rounded-full bg-black/70 p-1" data-testid="bacheca-link-remove"><X className="h-3 w-3" /></button>}
    </div>
  );
}

export function Carousel({ media, pid, onDoubleTap, overlayPrice, venduto }) {
  const ref = useRef(null);
  const [i, setI] = useState(0);
  const [burst, setBurst] = useState(0);
  const last = useRef(0);
  const [zoom, setZoom] = useState(null);
  if (!media.length) return null;
  const tap = (m, j) => {
    const t = Date.now();
    if (t - last.current < 300) { setBurst((b) => b + 1); onDoubleTap?.(); last.current = 0; return; }
    last.current = t;
    if (m.kind !== "video") setTimeout(() => { if (last.current === t) setZoom(j); }, 320);
  };
  return (
    <div className="relative select-none" data-testid={`bacheca-gallery-${pid}`}>
      <div ref={ref} onScroll={(e) => setI(Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth))}
        className="flex snap-x snap-mandatory overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {media.map((m, j) => (
          <div key={j} className="relative aspect-[4/5] w-full shrink-0 snap-center bg-black" onClick={() => tap(m, j)} data-testid={`bacheca-media-${pid}-${j}`}>
            {m.kind === "video"
              ? <video src={mediaSrc(m.url)} className="h-full w-full object-contain" controls playsInline preload="metadata" />
              : <img src={mediaSrc(m.url)} alt="" className="h-full w-full object-cover" loading="lazy" draggable={false} />}
          </div>
        ))}
      </div>
      {media.length > 1 && (
        <>
          <span className="absolute right-3 top-3 rounded-full bg-black/60 px-2 py-0.5 text-[11px] font-semibold text-white">{i + 1}/{media.length}</span>
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5">
            {media.map((_, j) => <span key={j} className="h-1.5 rounded-full transition-[width,background-color] duration-200" style={{ width: j === i ? 16 : 6, background: j === i ? "#C17F59" : "rgba(255,255,255,.5)" }} />)}
          </div>
        </>
      )}
      {overlayPrice && (
        <span className="absolute bottom-4 left-3 rounded-full border border-[#C17F59]/60 bg-black/75 px-3 py-1 font-heading text-base font-extrabold text-[#E59B6E] backdrop-blur" data-testid={`bacheca-price-${pid}`}>
          {venduto ? <s className="text-[#9CA3AF]">{price(overlayPrice)}</s> : price(overlayPrice)}
        </span>
      )}
      {burst > 0 && <img key={burst} src="/vesta-coin-rame.png" alt="" className="pointer-events-none absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 [animation:coinBurst_.8s_ease-out_forwards]" data-testid={`bacheca-coin-burst-${pid}`} />}
      {zoom !== null && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95" onClick={() => setZoom(null)} data-testid="bacheca-lightbox">
          <img src={mediaSrc(media[zoom].url)} alt="" className="max-h-[92vh] max-w-[96vw] object-contain" />
          <button type="button" className="absolute right-4 top-4 rounded-full bg-white/10 p-2" data-testid="bacheca-lightbox-close"><X className="h-5 w-5" /></button>
        </div>
      )}
    </div>
  );
}
